<template>
  <Catalogs
    title="Статусы лидов"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'LeadStatusAdd'"
    :route-edit="'LeadStatusEdit'"
    :route-view="'LeadStatusView'"
    :route-path="'/lead_statuses'"
    :can-edit="canEditLeadStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LeadStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'lead-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'lead-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getLeadStatuses(data);
    },
    canEditLeadStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_LEAD_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.lead-status-id {
  width: 60px;
  text-align: center;
}

.lead-status-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadStatuses/LeadStatuses.vue